import React from "react";
import ProductTemplate from "../../ProductTemplate";
import s700Cover from "../../../assets/s700/S700Cover.png";
import s700a from "../../../assets/s700/s700a.webp";
import s700b from "../../../assets/s700/s700b.webp";
import s700c from "../../../assets/s700/s700c.webp";
import s700d from "../../../assets/s700/s700d.webp";
import s7001 from "../../../assets/s700/s7001.webp";
import s7002 from "../../../assets/s700/s7002.webp";
import s7003 from "../../../assets/s700/s7003.webp";
import s7004 from "../../../assets/s700/s7004.webp";
import s7005 from "../../../assets/s700/s7005.webp";
import s7006 from "../../../assets/s700/s7006.webp";
import s7007 from "../../../assets/s700/s7007.webp";
import s7008 from "../../../assets/s700/s7008.webp";
import s7009 from "../../../assets/s700/s7009.webp";
import s70010 from "../../../assets/s700/s70010.webp";
import s70011 from "../../../assets/s700/s70011.webp";
import s70012 from "../../../assets/s700/s70012.webp";
import s70013 from "../../../assets/s700/s70013.webp";
import s70014 from "../../../assets/s700/s70014.webp";
import s700sec1 from "../../../assets/s700/s700sec1.webp";
import s700sec2 from "../../../assets/s700/s700sec2.webp";
import s700sec3 from "../../../assets/s700/s700sec3.webp";
import s700sec4 from "../../../assets/s700/s700sec4.webp";
import s700sec5 from "../../../assets/s700/s700sec5.webp";

const S700 = () => {
  const data = {
    title: "ALUMIL S700",
    subtitle: "Lift & slide insulated system SUPREME S700",
    description:
      "The lift & slide system SUPREME S700 represents the new generation of ALUMIL’s high-end systems. It is an excellent solution for projects with demanding requirements, meeting the trend of 'transparent' architecture through extensive glass surfaces, with high thermal insulation, safety, and modern design.",
    specifications: [
      { label: "THERMAL INSULATION", value: "Yes" },
      { label: "SASH DEPTH", value: "70 mm" },
      { label: "MINIMUM VISIBLE ALUMINIUM FACE WIDTH", value: "47 mm" },
      { label: "MAXIMUM GLAZING THICKNESS", value: "22 to 50 mm" },
      { label: "MECHANISM", value: "Lift & slide mechanism" },
      { label: "UW", value: "Uw=1,1W/m²K" },
      { label: "WATER TIGHTNESS", value: "CLASS E900" },
      { label: "AIR PERMEABILITY", value: "CLASS 4" },
      { label: "WIND LOAD RESISTANCE", value: "C4/B4" },
      { label: "SOUND REDUCTION", value: "41 dB" },
      { label: "BURGLAR RESISTANCE", value: "RC2" },
    ],
    renders: [s700Cover, s700a, s700b, s700c, s700d],
    typologies: [
      { image: s7001, caption: "Double lifting sliding sash" },
      { image: s7002, caption: "Double lifting sliding sash with narrow interlocking profile" },
      { image: s7003, caption: "Four lifting sliding sashes meeting stile" },
      { image: s7004, caption: "Four lifting sliding sashes meeting stile with narrow interlocking profile" },
      { image: s7005, caption: "Corner typology with four lifting sliding sashes" },
      { image: s7006, caption: "Triple lifting sliding sash" },
      { image: s7007, caption: "Six lifting sliding sashes with meeting stile" },
      { image: s7008, caption: "Single lifting sliding pocket sash with fly-screen & shutter" },
      { image: s7009, caption: "Double lifting sliding pocket sash with meeting stile, with fly-screen & shutter" },
      { image: s70010, caption: "Single lifting sliding sash with fixed light" },
      { image: s70011, caption: "Two lifting sliding sashes with fixed light" },
      { image: s70012, caption: "Single lifting sliding sash with two fixed lights" },
      { image: s70013, caption: "Double lifting sliding sash with meeting stile & with two fixed lights" },
      { image: s70014, caption: "Double lifting sliding sash with fly-screen" },
    ],
    sections: [s700sec1, s700sec2, s700sec3, s700sec4, s700sec5],
    relatedFiles: [
      {
        label: "S700 System Specs",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/pre-qualification-files/supreme/pre-qualification-s70039f086a1742c490dbdc0c64b3b9b2a75.pdf",
      },
      {
        label: "S700 Brochure",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/brochures/technical/supreme/s700_en.pdf?sfvrsn=7d3016c6_32",
      },
    ],
  };

  return <ProductTemplate {...data} />;
};

export default S700;